import { getCountryData } from 'src/assets/data';

// ----------------------------------------------------------------------

export const getIpData = (field) =>
  fetch('https://freeipapi.com/api/json/')
    .then((response) => response.json())
    .then((ipData) => {
      const countryData = getCountryData(ipData.countryName);
      const data = { ...ipData, ...countryData };
      return field ? data[field] : data;
    })
    .catch((error) => {
      console.error('IP data could not be loaded', error);
      return field ? '' : {};
    });
